import {Component, ComponentFactoryResolver, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {GeneralService} from '../../services/general.service';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {NewDocumentService} from '../../services/new-document.service';
import {SignDocumentPage} from '../sign-document/sign-document.page';
import {TestConnectionService} from '../../services/test-connection.service';
import {StateManagerService} from '../../services/state-manager.service';
import {DocumentTypes} from '../../definitions/document-types';
import {CollectionsNames} from '../../definitions/collections-names';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ContractPage} from '../contract/contract.page';
import {ContractHealthCare} from '../healthcare/contract-health-care/contract-health-care';
import {GenerateDocFromOrderService} from '../../services/generate-doc-from-order.service';
import {SignDocumentHealthCarePage} from '../healthcare/sign-document-health-care/sign-document-health-care.page';
import { HmheadDocTypes } from 'src/app/definitions/hmhead-doctypes';
import { ConfigurationModel } from 'src/app/models/configuration.model';
import { DocumentBeanQueueFiltersPage } from '../document-bean-queue-filters/document-bean-queue-filters.page';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DocumentBeanQueueQueryModel } from 'src/app/models/document-bean-queue-query.model';
import { DocumentResourceService } from 'src/app/services/database/resource/document-resource.service';
import { DocumentBeanQueueModel } from 'src/app/models/document-bean-queue.model';
import { ServiceJobDetailsPage } from '../service-job-details/service-job-details.page';

@Component({
    selector: 'app-document-bean-queue',
    templateUrl: './document-bean-queue.page.html',
    styleUrls: ['./document-bean-queue.page.scss'],
})
export class DocumentBeanQueuePage implements OnInit {
    configuration: ConfigurationModel;
    queuedDocs: any; // DocumentBeanQueueModel[];
    document: DocumentModel;
    queryText = '';
    loading: any;
    mobileConfig: MobileConfigurationModel;
    documentBeanQueueQuery: DocumentBeanQueueQueryModel;

    constructor(private generalServices: GeneralService,
                public modalController: ModalController,
                private refreshDataBase: RefreshdatabaseService,
                private newDocumentService: NewDocumentService,
                private loadingController: LoadingController,
                private testConnection: TestConnectionService,
                private stateManager: StateManagerService,
                private docTypes: DocumentTypes,
                private hmheadTypes: HmheadDocTypes,
                private collectionNames: CollectionsNames,
                private generateDocFromOrder: GenerateDocFromOrderService,
                private alertController: AlertController,
                private documentTypes: DocumentTypes,
                private configService: ConfigurationService,
                private documentResource: DocumentResourceService
                ) {
    }

    ngOnInit() {
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        this.initializeDocumentBeanQueueQuery();
       
    }

    private  initializeDocumentBeanQueueQuery(){
        // all dates need time set to 00:00
        // from date need to default to 7 days before
        this.documentBeanQueueQuery = new DocumentBeanQueueQueryModel();

        var fromDate = new Date();
        fromDate.setHours(0,0,0,0); // set to midnight ( start of the day)
        fromDate.setDate( fromDate.getDate() -7 ); // subtract a week

        var toDate = new Date();
        toDate.setHours(23,59,0,0); // set to 23:59 ( the end of this day );

        console.log("FromDate");
        console.log(fromDate);
        console.log("toDate");
        console.log(toDate);

        this.documentBeanQueueQuery.fromDate = fromDate.toISOString();
        this.documentBeanQueueQuery.toDate = toDate.toISOString();

        console.log(this.documentBeanQueueQuery.fromDate);
        console.log(this.documentBeanQueueQuery.toDate);

        
        this.documentBeanQueueQuery.operator = this.configuration.selectedOperator;
        this.documentBeanQueueQuery.location = this.configuration.selectedDepot;
    }
        

    ionViewWillEnter() {
        this.loadingFetchingDocs();
    }

    setIconDoc(id: any) {
        return this.generalServices.setIcon(id);
    }

    async refreshDocs(event){
        await this.loadingFetchingDocs();
        event.target.complete();
    }

    async loadingFetchingDocs() {
        await this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
            /*await this.fetchDocs().then(() => {
                this.loading.dismiss();
            });*/

            await this.documentResource.getDocumentBeanQueue( this.documentBeanQueueQuery ).then(data =>{
                this.queuedDocs = data;
                this.filterDocs();
                this.configService.hardSaveConfiguration(this.configuration);
                console.log( this.queuedDocs )
                this.loading.dismiss();
            });

          
            
            
        } catch (e) {
            console.log(e);
            this.generalServices.createToast('No connection with the server');
        } finally {
            this.loading.dismiss();
        }
    }

    private filterDocs() {
        if( this.configuration.documentBeanQueueOrdering === "ascending" ){
            this.queuedDocs.sort((a, b) => (a.documentBean.syncedAt > b.documentBean.syncedAt ) ? -1 : 1);
        }else{
            this.queuedDocs.sort((a, b) => (a.documentBean.syncedAt > b.documentBean.syncedAt ) ? 1 : -1);
        }
        
    }

    async openModalDocument(doc: DocumentModel) {
        let page = null;
        if (doc.serviceJob){
            this.document = doc;
            page = ServiceJobDetailsPage;
        }else{
            this.document = doc;
            page = SignDocumentPage;
        }




        this.document.isAlreadySynced = true;
        console.log( "loading synced document");
        console.log(this.document);
        const modal = await this.modalController.create({
            component: page,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then(res => {
            console.log("On Did Dismiss");
            console.log( res );
            if (res.data) {
                this.modalController.dismiss();
            }
        });
        return await modal.present();

    }

    cancelDocument() {
        this.modalController.dismiss();
    }

    docTypeDisplay(doc: DocumentModel) {
        if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.OFFHIRE ) {
            return 'Collection -';
        } else if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.RETURN ) {
            return 'Return -';
        } else if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.CONTRACT ) {
            return 'Delivery -';
        } else if (doc.documentType === 5) { // Doc Type 5 is Order in the backend
            return 'Order -';
        } else  if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.BREAKDOWN_COLLECTION ) {
            return 'Breakdown Collection -';
        } else  {
            return '';
        }
    }

    async showFilters() {
        const modal = await this.modalController.create({
            component: DocumentBeanQueueFiltersPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'configuration': this.configuration,
                'documentBeanQueueQuery': this.documentBeanQueueQuery
            }
        });


        modal.onDidDismiss().then((dataReturned) => {
            console.log( this.documentBeanQueueQuery);
            this.loadingFetchingDocs();
            /*this.documentResource.getDocumentBeanQueue( this.documentBeanQueueQuery ).then(data =>{
                this.queuedDocs = data;
                console.log( this.queuedDocs )
            });
            this.filterDocs();*/
            this.configService.hardSaveConfiguration(this.configuration);
        });

        return await modal.present();
    }

    jobTypeDescription(id: number) {
        const jobTypeList = this.stateManager.getCollection('jobtype');
        for (const type of jobTypeList) {
            if (type.id === id) {
                return type.description;
            }
        }
    }

    getSyncStatusColor(doc: DocumentBeanQueueModel) {
        var cl = "color: blue ";

        if( doc.status === 2 ){
            cl = "color: green";
        }
        
        if( doc.status === 3){
            cl = "color: red";
        }

        return cl;

    }

}
